import { Reducer } from 'react';
import { MainPageStore } from '../models';
import filePickerReducer from './filePicker';
import reducers from './reducers';

type Re = Reducer<MainPageStore, { payload: any; meta: any; type: string }>;

const reducer: Re = (state, action) =>
  reducers(filePickerReducer(state, action), action);

export default reducer;
